"use client";
import { useEffect, useState } from "react";
import { useWindowSize } from 'react-use'
//import { SpinCircle } from './SpinCircle'
import Confetti from 'react-confetti'
import { SpinWheel } from 'react-spin-wheel'
import "react-spin-wheel/dist/index.css"

export default function Home() {
  interface gage {
    name: string;
    description: string
  };
  const [gage, setGage] = useState<
    { name: string; description: string }
  >(null);
  const [gages, setGages] = useState<
    { name: string; description: string }[]
  >([]);
  const [confetti, setConfetti] = useState(false);
  const [index, setIndex] = useState<number | null>(null);
  const [choice, setChoice] = useState<gage | null>(null);
  const [spinning, setSpinning] = useState<boolean | null>(null);
  useEffect(() => {
    fetch("/api/gages")
      .then((res) => res.json())
      .then((data) => setGages(data));
  }, []);
  const { width, height } = useWindowSize()

  async function startRoulette() {
    const rdm = Math.floor(Math.random() * gages.length);
    for await (const i of Array(40).keys()) {
      await new Promise((resolve) => setTimeout(resolve, i * 5));
      setIndex(Math.floor(Math.random() * gages.length));
    }

    setIndex(rdm);
    setConfetti(true);
    setTimeout(() => setConfetti(false), 8000);
    
  }

  return (
    <div style={{ backgroundImage: `url(/public/logo.png)`}} className="flex flex-col justify-center items-center min-h-[80vh]">
      <h1 className="text-4xl font-bold text-center mb-2">
        Tourne la roue afou
      </h1>
      <div className="flex flex-row flex-wrap justify-center mt-4 items-center p-2 rounded-lg bg-white/10 w-80 m-2 border-2 border-purple-700 scale-125 opacity-100">
		<h2 className="text-2xl font-bold"> 
			{choice ? ((gages.find((gage) => gage.name === choice.name))?.description || "") :
				(spinning ? "Att 2 sec stp" :
				"Y A RIEEEEEEEN")
			}
		</h2>
      </div>
	  <SpinWheel
	  	items={gages}
		onResult={(item) => {
			setChoice(null);
			setSpinning(true);
		}}
		onFinishSpin={(gage) => {
			setConfetti(true);
			setSpinning(false);
			setChoice(gage);
			setTimeout(() => setConfetti(false), 8000);
		}}
		onReset={() => {
			setChoice(null);
			setSpinning(false);
			setConfetti(false);
		}}
	  />
      {confetti && (
           <Confetti
           width={width}
           height={height}
         /> 
      )}

    </div>
  );
}
